import manifests from "./sample-app-manifests.json";
import { AppManifest } from "common/components/SerializedApp";

export const sampleAppManifests = manifests as { [appId: string]: AppManifest };
